import { Pipe, PipeTransform } from '@angular/core';
import { IssueTypes } from '../globals';

@Pipe({
  name: 'issueTypeName'
})
export class IssueTypeNamePipe implements PipeTransform {

  transform(value: number, plural: boolean = false): string {
    switch (value) {
      case IssueTypes.Change:
        return plural? 'Changes': 'Change';

      case IssueTypes.Incident:
        return plural? 'Tickets': 'Ticket';

      case IssueTypes.Project:
        return plural? 'Projekte': 'Projekt';

      case IssueTypes.Issue:
        return plural? 'Vorgänge': 'Vorgang';
        
      default:
        return 'Unbekannt';
    }
  }

}
